<div class="gotocps-container">
    <div class="gotocps-header">
        <span class="gotocps-title">CPS</span>
    </div>
    <div class="gottocps-body">
        <a (click)="goToCps()">
            <div class="gotocps-img-container">
                <img class="gotocps-image" src="../../../assets/images/cps-logo-header.svg">
            </div>
            <div class="gotocps-footer-container">
                <span class="gotocps-footer">{{ 'Home.gotocps' | translate }}</span>
            </div>
        </a>
    </div>
</div>
